import React, { Component } from "react";
import Select from "react-select";
import { TextBox, TextArea } from "../../Components/InputElements";
import axios from "axios";
import Swal from "sweetalert2";
import withRouter from "../../Utils/withRouter";
import { NavLink } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { decodeData, genderOptions, titleOptions } from "../../Constants/constants";
class GuestEmployee extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    this.state = {
      // Candidate Details //////
      employee_id: 0,
      location_id: 0,
      From_date: "",
      To_date: "",
      Title: 'Mr',
      employee_gender: 'Male',
      Date_of_birth: "",
      employee_joining_date: "",
      Designation: [],
      Grade: [],
      Department: [],
      Location: [],
      SelectLevels: "",
      LinkValidDays: "",
      employee_name: "",
      employee_email_address: "",
      employee_mobile_number: "",
      employee_address: "",
      required_documents: [],
      required_letters: [],
      rows: [],
      letter_rows: [],
      selectedSalaryType: null,
      allowances: [],
      statutoryList: [],
      statutoryOptions: [],
      employee_contribution: '',
      employer_contribution: '',
      salary_heads_rows: [],
      company_salary_statutory_rows: [],
      company_salary_head_id: null,
      amount: "",
      ctc: "",
      rememberMe: false,
      documentMe: false,
      decodedData: [],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetSalaryHeadList();
      this.GetCompanyLetters();
      this.GetSalaryStatutoryList();
      this.GetListEmployeeDocumentType();
      this.GetDesignationMasters();
      this.GetGradeMasters();
      this.GetDepartmentMasters();
      this.GetLocationMasters();
    });
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleSelect(event) {
    this.setState({
      employee_gender: event.target.value
    });
  }


  handleInputCheck = (e) => {

    var index = this.state.required_documents.indexOf(e.target.value)
    var arr = this.state.required_documents;
    if (e.target.checked === true) {
      arr.push(e.target.value);
      this.setState({ required_documents: arr }, (prevState) => { })
    } else {
      arr.splice(index, 1);
      this.setState({ required_documents: arr }, (prevState) => { })
    }
  }

  GetListEmployeeDocumentType = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetCompanyEmployeeDocumentType`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleInputCheckLetter = (e) => {

    var index = this.state.required_letters.indexOf(e.target.value)
    var arr = this.state.required_letters;
    if (e.target.checked === true) {
      arr.push(e.target.value);
      this.setState({ required_letters: arr }, (prevState) => { })
    } else {
      arr.splice(index, 1);
      this.setState({ required_letters: arr }, (prevState) => { })
    }
  }

  GetCompanyLetters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetCompanyLettersList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            letter_rows: data.data,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  GetDesignationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.designation;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Designation: data.map((row) => ({
              value: row.designation_id,
              label: row.designation_title,
            })),
          }));
        }
      });
  };
  handleDesignationChange = (selectedOption) => {
    this.setState({
      designation_id: selectedOption.value,
    });
  };
  handleDepartmentChange = (selectedOption) => {
    this.setState({
      department_id: selectedOption.value,
    });
  };

  handleGradeChange = (selectedOption) => {
    this.setState({
      grade_id: selectedOption.value,
    });
  };

  handleLocationChange = (selectedOption) => {
    this.setState({
      location_id: selectedOption.value,
    });
  };
  GetGradeMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.grades;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Grade: data.map((row) => ({
              value: row.grade_id,
              label: row.grade_title,
            })),
          }));
        }
      });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };

  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };

  GetSalaryHeadList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSalaryHeadList`, { headers }).then((response) => {
      var data = response.data;
      if (response.data.success === true) {
        this.setState({
          salary_heads_rows: data.data.map((row) => ({
            value: row.company_salary_head_id,
            label: row.company_salary_head,
            amount: row.company_default_value,
          }))
        });
      }
    });
  }

  GetSalaryStatutoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSalaryStatutoryList`, { headers }).then((response) => {
      var data = response.data;
      if (response.data.success === true) {
        this.setState({
          company_salary_statutory_rows: data.data.map((row) => ({
            value: row.company_salary_statutory_id,
            label: row.company_salary_statutory_title,
            company_salary_statutory_ids: row.company_salary_statutory_ids,
            company_salary_statutory_employee_contribution: row.company_salary_statutory_employee_contribution,
            company_salary_statutory_employer_contribution: row.company_salary_statutory_employer_contribution,
            company_salary_statutory_calculate_upto: row.company_salary_statutory_calculate_upto
          }))
        });
      }
    });
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const gross = this.state.allowances.reduce((total, allowance) => total + parseFloat(allowance.amount), 0).toFixed(2);

    var formData = {
      // Candidate Details

      employee_from_date: this.state.From_date,
      employee_from_to: this.state.To_date,
      employee_title: this.state.Title,
      employee_gender: this.state.employee_gender,
      date_of_birth: this.state.Date_of_birth,
      employee_joining_date: this.state.employee_joining_date,
      designation_id: this.state.designation_id,
      department_id: this.state.department_id,
      grade_id: this.state.grade_id,
      location_id: this.state.location_id,
      employee_name: this.state.employee_name,
      employee_email_address: this.state.employee_email_address,
      employee_mobile_number: this.state.employee_mobile_number,
      employee_address: this.state.employee_address,
      required_documents: this.state.required_documents.join(','),
      required_letters: this.state.required_letters.join(','),
      salary_head: this.state.allowances,
      salary_statutory: this.state.statutoryList,
      gross: gross,
      ctc: this.state.ctc,
      salary_send: this.state.rememberMe,
      Document_send: this.state.documentMe,
      // Other fields as needed
    };


    if (this.state.employee_id !== 0) {
      formData.employee_id = this.state.employee_id;
    }



    Swal.fire({
      title: 'Please wait...',
      text: 'Processing your request',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    axios.post(`${apiURL}Employees/CreateEmployee`, formData, { headers })
      .then((response) => {
        Swal.close();
        const { success } = response.data;
        if (success === true && this.state.employee_id === 0) {
          this.setState({
            // Candidate Details //////

            From_date: "",
            To_date: "",
            Title: "",
            employee_email_address: "",
            employee_gender: "",
            Date_of_birth: "",
            employee_joining_date: "",
            Designation: "",
            SelectLevels: "",
            LinkValidDays: "",
            Location: "",
            employee_mobile_number: "",
            employee_address: "",
            required_documents: [],
            required_letters: [],
            selectedSalaryType: null,
            allowances: [],
            statutoryList: [],
            statutoryOptions: [],
            employee_contribution: '',
            employer_contribution: '',
            salary_heads_rows: [],
            company_salary_statutory_rows: [],
            company_salary_head_id: null,
            amount: "",
          });

          this.setState({ loadingList: true }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetCompanyLetters();
            this.GetSalaryStatutoryList();
            this.GetListEmployeeDocumentType();
            this.GetDesignationMasters();
            this.GetGradeMasters();
            this.GetDepartmentMasters();
            this.GetLocationMasters();
          });
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
          });
        } else {
          Swal.close();
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
          });
          this.setState({ loadingList: true }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetCompanyLetters();
            this.GetSalaryStatutoryList();
            this.GetListEmployeeDocumentType();
            this.GetDesignationMasters();
            this.GetGradeMasters();
            this.GetDepartmentMasters();
            this.GetLocationMasters();
          });
        }
      });
  };

  handleTypeChange = (selectedOption) => {
    // Extract the necessary data from the selected option
    const { value: company_salary_head_id } = selectedOption;

    // Update the state with the selected company_salary_head_id
    this.setState({
      selectedSalaryType: selectedOption,
      company_salary_head_id,
      // company_salary_head_id: selectedOption.company_salary_head_id,
      amount: selectedOption.amount,
    });
  };

  handleAmountChange = (e) => {
    this.setState({ amount: e.target.value });
  };

  handleAddAllowance = () => {
    const { selectedSalaryType, amount, allowances, company_salary_head_id } = this.state;
    if (!selectedSalaryType || !amount) {
      Swal.fire({
        icon: "warning",
        title: "<strong>Oops..</strong>",
        text: "Please select a salary type and enter an amount!",
        timer: 2000,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
      return;
    }
    if (selectedSalaryType && amount) {
      const newAllowance = {
        company_salary_head_id: company_salary_head_id,
        type: selectedSalaryType.label,
        amount: parseFloat(amount).toFixed(2),
      };

      this.setState({
        allowances: [...allowances, newAllowance],
        selectedSalaryType: null,
        amount: "",
      }, () => {
        this.handleCTCStatutory();
      });
    }
  };

  handleDeleteAllowance = (index) => {
    const { allowances } = this.state;
    const updatedAllowances = allowances.filter((_, i) => i !== index);
    this.setState({ allowances: updatedAllowances });
  };

  // company_salary_statutory //
  handleStatutoryTypeChange = (selectedOption) => {
    this.setState({
      statutoryType: selectedOption,
      employee_contribution: selectedOption.company_salary_statutory_employer_contribution,
      employer_contribution: selectedOption.company_salary_statutory_employee_contribution
    });

  };

  handleEmployeeContributionChange = (e) => {
    this.setState({ employee_contribution: e.target.value });
  };

  handleEmployerContributionChange = (e) => {
    this.setState({ employer_contribution: e.target.value });
  };

  handleAddStatutory = () => {
    const { statutoryType, employee_contribution, employer_contribution, statutoryList } = this.state;

    if (!statutoryType || !employee_contribution || !employer_contribution) {
      Swal.fire({
        icon: "warning",
        title: "<strong>Oops..</strong>",
        text: "Please Enter all fields!",
        timer: 2000,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
      return;
    }
    var sat_total_perc = Number(parseFloat(employee_contribution).toFixed(2)) + Number(parseFloat(employer_contribution).toFixed(2));
    var total_salary_for_calc = this.GetTotalSalaryBasedOnFarmula(statutoryType.company_salary_statutory_ids, statutoryType.company_salary_statutory_calculate_upto, sat_total_perc);

    var total = (total_salary_for_calc.total / 100) * sat_total_perc;
    const newStatutory = {
      company_salary_statutory_id: statutoryType.value,
      type: statutoryType.label,
      employee_contribution: parseFloat(employee_contribution).toFixed(2),
      employer_contribution: parseFloat(employer_contribution).toFixed(2),
      total_persent: Number(parseFloat(employee_contribution).toFixed(2)) + Number(parseFloat(employer_contribution).toFixed(2)),
      total: total,
      formula: total_salary_for_calc.formula,

    };
    this.setState({
      statutoryList: [...statutoryList, newStatutory],
      statutoryType: null,
      employee_contribution: '',
      employer_contribution: '',
    }, () => {
      this.handleCTCStatutory();
    });
  };
  handleCTCStatutory = () => {
    const { allowances, statutoryList } = this.state;
    const totalAllowances = allowances.reduce((total, allowance) => total + parseFloat(allowance.amount), 0);
    const totalStatutory = statutoryList.reduce((total, statutory) => total + parseFloat(statutory.total), 0);
    const ctc = totalAllowances - totalStatutory;
    this.setState({
      ctc: ctc.toFixed(2)
    });
  };

  GetTotalSalaryBasedOnFarmula = (ids, calculate_upto, percentage) => {
    var idsArr = ids.split(',');
    // return 10000;
    var heads = [];
    var total = 0;
    for (var i = 0; i < idsArr.length; i++) {
      for (var x = 0; x < this.state.allowances.length; x++) {
        if (Number(this.state.allowances[x].company_salary_head_id) === Number(idsArr[i])) {
          total += Number(this.state.allowances[x].amount);
          heads.push(this.state.allowances[x].type);
        }
      }
    }
    var formula = "(" + heads.join(' + ') + ") / 100 X %" + percentage;
    if (total > calculate_upto) {
      return calculate_upto;
    }
    return { total: total, formula: formula };
  }


  handleDeleteStatutory = (index) => {
    const { statutoryList } = this.state;
    const updatedStatutoryList = statutoryList.filter((_, i) => i !== index);
    this.setState({ statutoryList: updatedStatutoryList });
  };

  handleSelectTitle = selectedOption => {
    this.setState({ Title: selectedOption.value });
  };
  // company_salary_statutory //

  handlePreviousTab = (tabId) => {
    const prevTab = document.getElementById(tabId);
    if (prevTab) {
      prevTab.click();
    }
  };

  handleNextTab = (tabId) => {
    const nextTab = document.getElementById(tabId);
    if (nextTab) {
      nextTab.click();
    }
  };


  handleRememberMeChange = (event) => {
    this.setState({ rememberMe: event.target.checked });
  };

  handleDocumentMeChange = (event) => {
    this.setState({ documentMe: event.target.checked });
  };

  render() {
    const { selectedSalaryType, amount, allowances, } = this.state;

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title mb-0">Guest Employee</h4>
                  </div>

                  <div className="card-body form-steps">
                    <div className="vertical-navs-step">
                      <div className="row gy-5">
                        <div className="col-lg-3">
                          <div
                            className="nav flex-column custom-nav nav-pills"
                            role="tablist"
                            aria-orientation="vertical"
                          >
                            <button
                              className="nav-link active"
                              id="v-pills-bill-info-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-bill-info"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-bill-info"
                              aria-selected="true"
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                Step 1
                              </span>
                              Candidate Details
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-bill-address-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-bill-address"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-bill-address"
                              aria-selected="false"
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                Step 2
                              </span>
                              Salary Details
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-payment-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-payment"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-payment"
                              aria-selected="false"
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                Step 3
                              </span>
                              Required Documents
                            </button>
                            <button
                              className="nav-link"
                              id="v-pills-finish-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-finish"
                              type="button"
                              role="tab"
                              aria-controls="v-pills-finish"
                              aria-selected="false"
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                Step 4
                              </span>
                              Letter Details
                            </button>


                          </div>

                        </div>{" "}

                        <div className="col-lg-9">
                          <div className="px-lg-4">
                            <div className="tab-content">
                              <div
                                className="tab-pane fade show active"
                                id="v-pills-bill-info"
                                role="tabpanel"
                                aria-labelledby="v-pills-bill-info-tab"
                              >
                                <div>
                                  <h5>
                                    Candidate Details{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        marginLeft: "5px",
                                        borderRadius: "50%",
                                        background: "#f0f8ff",
                                        padding: "2px 6px",
                                        display: "inline-block",
                                        textAlign: "center",
                                        width: "20px",
                                        height: "20px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      *
                                    </span>
                                  </h5>
                                  <p className="text-muted">
                                    Fill all information below
                                  </p>
                                </div>

                                <div>
                                  <div className="row g-3">
                                    <div className="col-sm-6">
                                      <TextBox
                                        type="TextArea"
                                        id=""
                                        name=""
                                        label="Reference code"
                                        hint="Enter Reference code"
                                      // value={this.state.}
                                      // change={this.handleInputChange}
                                      />
                                    </div>
                                    <div className="col-sm-6">

                                      <label
                                        htmlFor="Title"
                                        className="form-label"
                                      >
                                        Title
                                      </label>
                                      <Select
                                        id="Title"
                                        name="Title"
                                        value={titleOptions.find(option => option.value === this.state.Title)}
                                        onChange={this.handleSelectTitle}
                                        options={titleOptions}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="text"
                                        id="employee_name"
                                        name="employee_name"
                                        label={
                                          <span>
                                            Candidate name{" "}
                                            <span
                                              style={{
                                                color: "blue",
                                                borderRadius: "50%",
                                                background: "#f0f8ff",
                                                padding: "2px 6px",
                                                display: "inline-block",
                                                textAlign: "center",
                                                width: "20px",
                                                height: "20px",
                                                lineHeight: "20px",
                                              }}
                                            >
                                              *
                                            </span>
                                          </span>
                                        }
                                        hint="Enter Candidate name"
                                        value={this.state.employee_name}
                                        change={this.handleInputChange}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="Number"
                                        id="employee_mobile_number"
                                        name="employee_mobile_number"
                                        label={
                                          <span>
                                            Mobile{" "}
                                            <span
                                              style={{
                                                color: "blue",
                                                borderRadius: "50%",
                                                background: "#f0f8ff",
                                                padding: "2px 6px",
                                                display: "inline-block",
                                                textAlign: "center",
                                                width: "20px",
                                                height: "20px",
                                                lineHeight: "20px",
                                              }}
                                            >
                                              *
                                            </span>
                                          </span>
                                        }
                                        hint="Enter Mobile"
                                        value={
                                          this.state.employee_mobile_number
                                        }
                                        change={this.handleInputChange}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="email"
                                        id="employee_email_address"
                                        name="employee_email_address"
                                        label={
                                          <span>
                                            E-mail{" "}
                                            <span
                                              style={{
                                                color: "blue",
                                                borderRadius: "50%",
                                                background: "#f0f8ff",
                                                padding: "2px 6px",
                                                display: "inline-block",
                                                textAlign: "center",
                                                width: "20px",
                                                height: "20px",
                                                lineHeight: "20px",
                                              }}
                                            >
                                              *
                                            </span>
                                          </span>
                                        }
                                        hint="Enter E-mail"
                                        value={
                                          this.state.employee_email_address
                                        }
                                        change={this.handleInputChange}
                                      />
                                    </div>


                                    <div className="col-sm-6">

                                      <label htmlFor="employee_gender" className="form-label">Gender</label>
                                      <Select
                                        id="employee_gender"
                                        name="employee_gender"
                                        value={genderOptions.find(option => option.value === this.state.employee_gender) || null}
                                        onChange={this.handleSelect}
                                        options={genderOptions}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="Date"
                                        id="Date_of_birth"
                                        name="Date_of_birth"
                                        label="Date of birth"
                                        hint=""
                                        value={this.state.Date_of_birth}
                                        change={this.handleInputChange}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="Date"
                                        id="From_date"
                                        name="From_date"
                                        label={
                                          <span>
                                            From date <span className="text-muted">(for non-regular employee)</span>

                                          </span>
                                        }
                                        hint=""
                                        value={this.state.From_date}
                                        change={this.handleInputChange}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="Date"
                                        id="To_date"
                                        name="To_date"
                                        label={
                                          <span>
                                            To date <span className="text-muted">(for non-regular employee)</span>

                                          </span>
                                        }
                                        hint=""
                                        value={this.state.To_date}
                                        change={this.handleInputChange}
                                      />
                                    </div>
                                    <div className="col-sm-6">

                                      <label
                                        htmlFor="Location"
                                        className="form-label"
                                      >
                                        Location
                                      </label>
                                      <Select
                                        options={this.state.Location}
                                        onChange={this.handleLocationChange}
                                        hint={`Select Location`}
                                      />
                                    </div>

                                    <div className="col-sm-6">

                                      <label
                                        htmlFor="Department"
                                        className="form-label"
                                      >
                                        Department
                                      </label>
                                      <Select
                                        options={this.state.Department}
                                        onChange={this.handleDepartmentChange}
                                        hint={`Select Department`}
                                      />
                                    </div>

                                    <div className="col-sm-6">

                                      <label
                                        htmlFor="Designation"
                                        className="form-label"
                                      >
                                        Designation
                                      </label>
                                      <Select
                                        options={this.state.Designation}
                                        onChange={this.handleDesignationChange}
                                        hint={`Select Designation`}
                                      />
                                    </div>

                                    <div className="col-sm-6">
                                      <label
                                        htmlFor="Grade"
                                        className="form-label"
                                      >
                                        Grade
                                      </label>
                                      <Select
                                        options={this.state.Grade}
                                        onChange={this.handleGradeChange}
                                        hint={`Select Grade`}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextBox
                                        type="Date"
                                        id="employee_joining_date"
                                        name="employee_joining_date"
                                        label="Joining date"
                                        hint=""
                                        value={this.state.employee_joining_date}
                                        change={this.handleInputChange}
                                      />
                                    </div>

                                    <div className="col-6">
                                      <TextArea
                                        type="text"
                                        id="employee_address"
                                        name="employee_address"
                                        label={
                                          <span>
                                            Employee current address{" "}
                                            <span
                                              style={{
                                                color: "blue",
                                                borderRadius: "50%",
                                                background: "#f0f8ff",
                                                padding: "2px 6px",
                                                display: "inline-block",
                                                textAlign: "center",
                                                width: "20px",
                                                height: "20px",
                                                lineHeight: "20px",
                                              }}
                                            >
                                              *
                                            </span>
                                          </span>
                                        }
                                        hint="Enter Communication address"
                                        value={this.state.employee_address}
                                        change={this.handleInputChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-start gap-3 mt-4">
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                    onClick={() =>
                                      this.handleNextTab(
                                        "v-pills-bill-address-tab"
                                      )
                                    }
                                    data-nexttab="v-pills-bill-address-tab"
                                  >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                    Next
                                  </button>

                                  <NavLink
                                    className="btn btn-success btn-label waves-effect right waves-light"
                                    to={"/CandidateDetailsList"}
                                  >
                                    <i className="bx bx-list-ul label-icon align-middle fs-16 ms-2" />{" "}
                                    List
                                  </NavLink>

                                </div>
                              </div>

                              <div
                                className="tab-pane fade"
                                id="v-pills-bill-address"
                                role="tabpanel"
                                aria-labelledby="v-pills-bill-address-tab"
                              >
                                <div>
                                  <div className="row g-3">
                                    <div>
                                      <h5>
                                        Salary Details{" "}
                                        <span
                                          style={{
                                            color: "blue",
                                            borderRadius: "50%",
                                            background: "#f0f8ff",
                                            padding: "2px 6px",
                                            display: "inline-block",
                                            textAlign: "center",
                                            width: "20px",
                                            height: "20px",
                                            lineHeight: "20px",
                                          }}
                                        >
                                          *
                                        </span>
                                      </h5>
                                      <p className="text-muted">
                                        Fill all information below
                                      </p>
                                    </div>

                                    <div>
                                      <p className="mb-0 h6">
                                        Select Salary Type
                                      </p>
                                      <div className="py-3 mb-3 d-flex justify-content-between align-items-center">
                                        <div className="w-25">
                                          <Select
                                            options={this.state.salary_heads_rows}
                                            onChange={this.handleTypeChange}
                                            value={selectedSalaryType}
                                          />
                                        </div>
                                        <div className="">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Amount"
                                            value={amount}
                                            onChange={this.handleAmountChange}
                                            id="cleave-numeral"
                                          />
                                        </div>
                                        <div className="">
                                          <button
                                            type="button"
                                            className="btn btn-success btn-label waves-effect right waves-light"
                                            onClick={this.handleAddAllowance}
                                          >
                                            <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" />{" "}
                                            Add
                                          </button>
                                        </div>
                                      </div>
                                      <table
                                        className="table table-nowrap table-sm text-center"
                                        style={{ marginBottom: "50px" }}
                                      >
                                        <thead className="table-light ">
                                          <tr>
                                            <th scope="col">Allowance Type</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {allowances.map(
                                            (allowance, index) => (
                                              <tr key={index}>
                                                <td>{allowance.type}</td>
                                                <td>{allowance.amount}</td>
                                                <td>
                                                  <button
                                                    type="button"
                                                    className="btn btn-link text-danger fs-15"
                                                    onClick={() =>
                                                      this.handleDeleteAllowance(
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <i className="ri-delete-bin-line" />
                                                  </button>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                        <tfoot className="table-light">
                                          <tr>
                                            <th scope="rowgroup" colSpan="1">
                                              GROSS
                                            </th>
                                            <th scope="rowgroup" colSpan="1">
                                              {allowances
                                                .reduce(
                                                  (total, allowance) =>
                                                    total +
                                                    parseFloat(
                                                      allowance.amount
                                                    ),
                                                  0
                                                )
                                                .toFixed(2)}
                                            </th>
                                            <th
                                              scope="rowgroup"
                                              colSpan="1"
                                            ></th>
                                          </tr>
                                        </tfoot>
                                      </table>
                                    </div>

                                    <div>
                                      <h5>
                                        Statutory Details{" "}
                                        <span
                                          style={{
                                            color: "blue",
                                            borderRadius: "50%",
                                            background: "#f0f8ff",
                                            padding: "2px 6px",
                                            display: "inline-block",
                                            textAlign: "center",
                                            width: "20px",
                                            height: "20px",
                                            lineHeight: "20px",
                                          }}
                                        >
                                          *
                                        </span>
                                      </h5>
                                      <p className="text-muted">
                                        Fill all information below
                                      </p>
                                    </div>

                                    <div>
                                      <p className="mb-0 h6">Statutory contributions Type</p>
                                      <div className="py-3 mb-3 d-flex justify-content-between align-items-center">
                                        <div className="w-25">
                                          <Select options={this.state.company_salary_statutory_rows} onChange={this.handleStatutoryTypeChange} />
                                        </div>
                                        <div className="">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Employee"
                                            value={this.state.employee_contribution}
                                            onChange={this.handleEmployeeContributionChange}
                                          />
                                        </div>
                                        <div className="">
                                          <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Employer"
                                            value={this.state.employer_contribution}
                                            onChange={this.handleEmployerContributionChange}
                                          />
                                        </div>
                                        <div className="">
                                          <button
                                            type="button"
                                            className={`btn btn-success btn-label waves-effect right waves-light ${allowances.length === 0 ? 'disabled' : ''}`}
                                            onClick={this.handleAddStatutory}
                                            disabled={allowances.length === 0}
                                          >
                                            <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" /> Add
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <table
                                      className="table table-nowrap table-sm text-center"
                                      style={{ marginBottom: "50px" }}
                                    >
                                      <thead className="table-light ">
                                        <tr>
                                          {/* <th scope="col" width="10%">Id</th> */}
                                          <th scope="col ">Statutory Type</th>
                                          <th scope="col">Employee</th>

                                          <th scope="col">Employeer</th>
                                          <th scope="col">Total</th>
                                          <th scope="col">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.statutoryList.map((statutory, index, row) => (
                                          <tr key={index}>
                                            <td>{statutory.type} <br /><small className="text-muted">{statutory.formula}</small></td>
                                            <td>{statutory.employee_contribution}</td>
                                            <td>{statutory.employer_contribution}</td>

                                            <td>
                                              {statutory.total}
                                            </td>
                                            <td>
                                              <button
                                                type="button"
                                                className="btn btn-link text-danger fs-15"
                                                onClick={() => this.handleDeleteStatutory(index)}
                                              >
                                                <i className="ri-delete-bin-line" />
                                              </button>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                      <tfoot className="table-light">
                                        <tr>
                                          <th scope="rowgroup" colSpan="2">
                                            CTC
                                          </th>
                                          <th scope="rowgroup" colSpan="2">
                                            {this.state.ctc}
                                          </th>
                                          <th scope="rowgroup" colSpan="2"></th>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                </div>
                                <div className="d-flex align-items-start gap-3 mt-4">
                                  <button
                                    type="button"
                                    className="btn btn-light btn-label previestab"
                                    onClick={() =>
                                      this.handlePreviousTab(
                                        "v-pills-bill-info-tab"
                                      )
                                    }
                                    data-previous="v-pills-bill-info-tab"
                                  >
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                    Back
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                    onClick={() =>
                                      this.handleNextTab("v-pills-payment-tab")
                                    }
                                    data-nexttab="v-pills-payment-tab"
                                  >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                    Next
                                  </button>
                                </div>
                              </div>
                              {/* end tab pane */}
                              <div
                                className="tab-pane fade"
                                id="v-pills-payment"
                                role="tabpanel"
                                aria-labelledby="v-pills-payment-tab"
                              >
                                <div>
                                  <h5>
                                    Required Documents{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        borderRadius: "50%",
                                        background: "#f0f8ff",
                                        padding: "2px 6px",
                                        display: "inline-block",
                                        textAlign: "center",
                                        width: "20px",
                                        height: "20px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      *
                                    </span>
                                  </h5>
                                  <p className="text-muted">
                                    Fill all information below
                                  </p>
                                </div>

                                <div className="card">
                                  <div className="card-body">
                                    <div className="d-flex align-items-center mb-4">
                                      <h5 className="card-title flex-grow-1 mb-0">
                                        Documents
                                      </h5>
                                      <div className="flex-shrink-0">
                                        <input
                                          className="form-control d-none"
                                          type="file"
                                          id="formFile"
                                        />
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="table-responsive">
                                          <table className="table table-borderless align-middle mb-0">
                                            <thead className="table-light">
                                              <tr>
                                                <th scope="col" width="90%">
                                                  Document
                                                </th>

                                                <th
                                                  scope="col"
                                                  width="10%"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.rows.map((row) => {
                                                return (
                                                  <tr key={row.employee_document_type_id}>
                                                    <td>{row.employee_document_type_title}</td>
                                                    <td className="d-flex justify-content-around">
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="checkAll"
                                                        value={row.employee_document_type_id}
                                                        onChange={this.handleInputCheck}

                                                      />
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-start gap-3 mt-4">
                                  <button
                                    type="button"
                                    className="btn btn-light btn-label previestab"
                                    onClick={() =>
                                      this.handlePreviousTab(
                                        "v-pills-bill-address-tab"
                                      )
                                    }
                                    data-previous="v-pills-bill-address-tab"
                                  >
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                    Back
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-label right ms-auto nexttab nexttab"
                                    onClick={() =>
                                      this.handleNextTab("v-pills-finish-tab")
                                    }
                                    data-nexttab="v-pills-finish-tab"
                                  >
                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                    Next
                                  </button>

                                </div>
                              </div>
                              {/* end tab pane */}

                              <div
                                className="tab-pane fade"
                                id="v-pills-finish"
                                role="tabpanel"
                                aria-labelledby="v-pills-finish-tab"
                              >
                                <div>
                                  <h5>
                                    Letter Details{" "}
                                    <span
                                      style={{
                                        color: "blue",
                                        borderRadius: "50%",
                                        background: "#f0f8ff",
                                        padding: "2px 6px",
                                        display: "inline-block",
                                        textAlign: "center",
                                        width: "20px",
                                        height: "20px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      *
                                    </span>
                                  </h5>
                                  <p className="text-muted">
                                    Fill all information below
                                  </p>
                                </div>
                                <div className="row">
                                  {this.state.letter_rows.map((row) => {
                                    return (
                                      <div className="col-md-4" key={row.company_letter_id}>
                                        {/* Simple card */}
                                        <div className="card profile-project-card shadow-none profile-project-primary p-2">
                                          <div style={{ height: '150px', overflow: 'hidden' }}>
                                            <img className="card-img-top img-fluid" src={row.letterhead_url} alt="Letter Img ??" />
                                          </div>
                                          <div className="card-body">
                                            <h4 className="card-title mb-2">{row.company_letter_title}</h4>

                                          </div>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkAll"
                                            value={row.company_letter_id}
                                            onChange={this.handleInputCheckLetter}

                                          />

                                        </div>{/* end card */}
                                      </div>
                                    );
                                  }
                                  )}
                                </div>
                                <div className="mb-3">
                                  <div className="mt-3 mb-3" style={{ border: "1.5px solid #c7c7c7", width: "100%" }}></div>
                                  <div className="form-check" style={{ float: "right" }}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="auth-remember-check"
                                      checked={this.state.rememberMe}
                                      onChange={this.handleRememberMeChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="auth-remember-check"
                                    >
                                      Do You Want to Share Salary Details
                                    </label>
                                  </div>
                                </div>
                                <div className="d-flex align-items-start mt-5">
                                  <button
                                    type="button"
                                    className="btn btn-light btn-label previestab"
                                    onClick={() =>
                                      this.handlePreviousTab(
                                        "v-pills-bill-address-tab"
                                      )
                                    }
                                    data-previous="v-pills-bill-address-tab"
                                  >
                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                    Back
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-success btn-label ms-auto waves-effect right waves-light"
                                    onClick={this.handleSubmit}
                                  >
                                    <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" />{" "}
                                    Submit
                                  </button>
                                </div>
                              </div>
                              {/* end tab pane */}
                            </div>
                            {/* end tab content */}
                          </div>
                        </div>
                        {/* end col */}
                      </div>
                      {/* end row */}
                    </div>
                  </div>
                </div>
                {/* end */}
              </div>
              {/* end col */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(GuestEmployee);